import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Check from 'react-feather/dist/icons/check.js';
import Tooltip from 'rc-tooltip';

import './BlueCheck.scss';

export default class BlueCheck extends PureComponent {
  static propTypes = {
    hasTooltip: PropTypes.bool,
    tooltipOverlay: PropTypes.string,
  };

  static defaultProps = {
    className: '',
    hasTooltip: false,
  };

  render() {
    if(this.props.hasTooltip) {
      return (
        <Tooltip placement="bottom" overlay={this.props.tooltipOverlay}>
          <div className="blue-check">
            <Check size={20} stroke="#FFFFFF" />
          </div>
        </Tooltip>
      );
    } else {
      return (
        <div className="blue-check">
          <Check size={20} stroke="#FFFFFF" />
        </div>
      );
    }
  }
}